import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withModifiers as _withModifiers, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createCommentVNode as _createCommentVNode, vShow as _vShow, withDirectives as _withDirectives, normalizeStyle as _normalizeStyle } from "vue"
import _imports_0 from '@/assets/images/videoIcon.png'
import _imports_1 from '@/assets/images/noneAudio.png'


const _hoisted_1 = { class: "audio-container" }
const _hoisted_2 = { class: "audio-list-container" }
const _hoisted_3 = { class: "content-box" }
const _hoisted_4 = { class: "audio-header" }
const _hoisted_5 = { class: "audio-list-title" }
const _hoisted_6 = { class: "audio-list-content" }
const _hoisted_7 = {
  key: 0,
  class: "audion-content"
}
const _hoisted_8 = { class: "audio-item-container" }
const _hoisted_9 = ["onClick"]
const _hoisted_10 = ["src"]
const _hoisted_11 = {
  key: 0,
  class: "video-icon",
  src: _imports_0,
  alt: ""
}
const _hoisted_12 = { class: "audio-item-title" }
const _hoisted_13 = { class: "page-contianer" }
const _hoisted_14 = { class: "total-count" }
const _hoisted_15 = {
  key: 1,
  class: "none-audion-content"
}
const _hoisted_16 = { class: "audion-detail-container" }
const _hoisted_17 = { class: "content-box" }
const _hoisted_18 = { class: "audio-header" }
const _hoisted_19 = { class: "audio-list-title" }
const _hoisted_20 = { class: "detail-header-lft" }
const _hoisted_21 = { class: "detail-content" }
const _hoisted_22 = { class: "zome-view-container" }
const _hoisted_23 = { class: "zome-preview-next" }
const _hoisted_24 = { class: "image-view-container" }
const _hoisted_25 = {
  key: 0,
  class: "reference-photos"
}
const _hoisted_26 = { class: "reference-photos-inner" }
const _hoisted_27 = ["src"]
const _hoisted_28 = ["src"]
const _hoisted_29 = { class: "zome-preview-next" }
const _hoisted_30 = { class: "zome-action-container" }
const _hoisted_31 = { class: "zome-action-inner" }

import { ref, reactive, onMounted, onBeforeMount, watch, computed,getCurrentInstance } from 'vue'
import { useRoute } from 'vue-router'
import { useStore } from 'vuex'
import { createDiscreteApi } from "naive-ui"
import { getActionListByScoresId } from '@/service'
import { $enum } from '@/global'
/////////////////////////////////////////////// 状态

export default /*@__PURE__*/_defineComponent({
  __name: 'index',
  props: {
    trainId: {
        type: String,
        default: null
    },
},
  emits: ['onBack'],
  setup(__props, { emit: __emit }) {

const { proxy } = getCurrentInstance()!
const route = useRoute() // 路由
const store = useStore() // 状态管理
const $emits = __emit // 自定义事件
const props = __props;

const state = reactive({
    trainingId: props.trainId,
    // trainingId: '1988151448555200512',
    baseUrl: process.env.VUE_APP_FILE_URL,
    isShowDialog: false,
    total: 0,
    sourceList: [] as any[],
    pagination: {
        size: 20,
        current: 1,
        totalSize: 0,
        pageSizes: [20, 40, 60, 80]
    },
    scale: 1,
    dragging: false,
    offsetX: 0,
    offsetY: 0,
    startX: 0,
    startY: 0,
    currentResourceIndex: 0,
    noneData: true,
    isShowPrevBtn: false,
    anomaliesOnly:false,
    showReferenceImage:true,
})
const pagination = reactive({
    pageSize: 12,
    current: 1,
    total: 0
})
const zoomScale = {
    max: 10,
    min: 0.25,
    step: 0.5
};
// 缩放原点
const origin = ref('center center');
// 缩放百分比
const scalePercentage = computed(() => Math.round(state.scale * 100));
/////////////////////////////////////////////// watch/computed
const imageStyle = computed(()=>{
    return {
        transform: `translate(${state.offsetX}px, ${state.offsetY}px) scale(${state.scale})`,
        cursor: state.dragging ? 'grabbing' : 'grab',
    };
})

const imageSrc = computed(()=>{
    if(Array.isArray(state.sourceList) && state.sourceList.length){
        resetImage();
        return state.sourceList[state.currentResourceIndex].actionUrl;
    }
    return '';
})

//参考照片
const referenceUrl = computed(()=>{
    if(Array.isArray(state.sourceList) && state.sourceList.length){
        return state.sourceList[state.currentResourceIndex]?.referenceUrl;
    }
    return '';
})

const imageIsPass = computed(()=>{
    if(Array.isArray(state.sourceList) && state.sourceList.length){
        return state.sourceList[state.currentResourceIndex]?.isPass;
    }
    return false;
})

const actionNamge = computed(()=>{
    if(Array.isArray(state.sourceList) && state.sourceList.length){
        return state.sourceList[state.currentResourceIndex].pointName;
    }
    return '';
})

// 不合格描述
const unqualifiedDescription = computed(()=>{
    if(Array.isArray(state.sourceList) && state.sourceList.length){
        const errorStr = (Array.isArray(state.sourceList[state.currentResourceIndex].errorItems) ? state.sourceList[state.currentResourceIndex].errorItems : [])
            .map(item => item.errorDesc)
            .filter(Boolean)
            .join('；') ?? ''
        return errorStr;
    }
    return '';
})
/////////////////////////////////////////////// 方法
function toggleAbnormal(){
    window?.playClick()
    state.anomaliesOnly = !state.anomaliesOnly;
    state.pagination.current = 1;
    getResoureceList();
}

function handleBack() {
    window?.playClick()
    // proxy?.vknMessage.close()
    $emits('onBack');
}

function handleShowDialog(item: any, index: number) {
    state.currentResourceIndex = index;
    state.isShowDialog = !state.isShowDialog;
}


async function getResoureceList(callback?:Function) {
    let params = {
        current: state.pagination.current,
        size: state.pagination.size,
        trainingId: state.trainingId,
        onlyNotPass: state.anomaliesOnly,
    }
    state.sourceList = [];
    const {code, data} = await getActionListByScoresId(params);
    if (code == $enum.EnumResult.SUCCESS) {
        const {total, pages, records} = data as any || {};
        state.total = Number(total) || 0;
        state.pagination.totalSize = pages;
        state.sourceList = records;
        if (!state.sourceList.length) {
            state.noneData = true;
        } else {
            state.noneData = false;
        }
        if (callback) {
            callback();
        }

    } else {
        state.total = 0;
        state.pagination.totalSize = 0;
        proxy?.vknMessage.error('获取数据失败!')
        state.noneData = true;
    }
}

/**
* 上一个资源
*/
function prevResource(){
    window?.playClick()
    if(state.pagination.current == 1 && state.currentResourceIndex == 0) return;
    if(state.currentResourceIndex > 0){
        --state.currentResourceIndex;
        return;
    }
    --state.pagination.current;
    getResoureceList(()=>{
        state.currentResourceIndex = state.sourceList.length - 1;
    });
}

/**
* 下一个资源
*/
function nextResource(){
    window?.playClick()
    if(state.pagination.current == state.pagination.totalSize && state.currentResourceIndex == state.sourceList.length - 1) return;
    if(state.currentResourceIndex <  state.sourceList.length - 1){
      ++state.currentResourceIndex;
      return;
    }
    ++state.pagination.current;
    getResoureceList(()=>{
        state.currentResourceIndex =0;
    });
}

function startDrag(event: MouseEvent) {
    const target = event?.target as HTMLElement | null;
    if (target && !target.classList.contains("draggable-image")) return;
    state.dragging = true;
    state.startX = event.clientX - state.offsetX;
    state.startY = event.clientY - state.offsetY;
}

function doDrag(event: MouseEvent) {
    if (!state.dragging) return;
    state.offsetX = event.clientX - state.startX;
    state.offsetY = event.clientY - state.startY;
}

function stopDrag(){
    state.dragging = false;
}

function zoom(event: WheelEvent){
    window?.playClick()
    event.preventDefault();
    const delta = event.deltaY < 0 ? 0.1 : -0.1; // 调整缩放比例
    state.scale += delta;
    state.scale = Math.max(zoomScale.min, Math.min(state.scale, zoomScale.max)); // 限制缩放范围
}

// 放大功能
const zoomIn = () => {
    window?.playClick()
    state.scale += zoomScale.step;
    state.scale = Math.max(zoomScale.min, Math.min(state.scale, zoomScale.max));
};

// 缩小功能
const zoomOut = () => {
    window?.playClick()
    state.scale -= zoomScale.step;
    state.scale = Math.max(zoomScale.min, Math.min(state.scale, zoomScale.max));
};

function resetImage(){
    window?.playClick()
    state.scale = 1;
    state.offsetX = 0;
    state.offsetY = 0;
}

function handleKeyUp(event: any) {
  if (event.key == "Escape") {
    handleBack();
  }
}
function handleCurrentChange(val:number) {
    window?.playClick()
    state.pagination.current = val;
    getResoureceList();
}

function handleSizeChange(val:number) {
    window?.playClick()
    state.pagination.size = val;
    getResoureceList();
}

/////////////////////////////////////////////// 生命周期
onBeforeMount(() => {
    getResoureceList();
    window.addEventListener('keyup', handleKeyUp);
})

return (_ctx: any,_cache: any) => {
  const _component_vkm_svg = _resolveComponent("vkm-svg")!
  const _component_el_radio = _resolveComponent("el-radio")!
  const _component_el_scrollbar = _resolveComponent("el-scrollbar")!
  const _component_el_pagination = _resolveComponent("el-pagination")!
  const _component_vkn_button = _resolveComponent("vkn-button")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _withDirectives(_createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _createVNode(_component_vkm_svg, {
              "icon-name": "back",
              class: "icon",
              onClick: handleBack
            }),
            _cache[3] || (_cache[3] = _createElementVNode("span", null, "相册", -1))
          ]),
          _createVNode(_component_el_radio, {
            modelValue: state.anomaliesOnly,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((state.anomaliesOnly) = $event)),
            label: true,
            onClick: _withModifiers(toggleAbnormal, ["prevent"])
          }, {
            default: _withCtx(() => _cache[4] || (_cache[4] = [
              _createTextVNode("只看异常")
            ])),
            _: 1
          }, 8, ["modelValue"])
        ]),
        _createElementVNode("div", _hoisted_6, [
          (!state.noneData)
            ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                _createElementVNode("div", _hoisted_8, [
                  _createVNode(_component_el_scrollbar, { class: "item-content" }, {
                    default: _withCtx(() => [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(state.sourceList, (item, index) => {
                        return (_openBlock(), _createElementBlock("div", {
                          class: "audio-item",
                          key: index,
                          onClick: ($event: any) => (handleShowDialog(item, index))
                        }, [
                          _createElementVNode("div", {
                            class: _normalizeClass(['prompt-container', item?.isPass ? 'qualified' : 'unqualified'])
                          }, [
                            _createElementVNode("span", null, _toDisplayString(item?.isPass ? '合格' : '不合格'), 1)
                          ], 2),
                          _createElementVNode("img", {
                            class: "photo",
                            src: `${state.baseUrl}${item.actionUrl}`,
                            alt: ""
                          }, null, 8, _hoisted_10),
                          (item.actionType == 2)
                            ? (_openBlock(), _createElementBlock("img", _hoisted_11))
                            : _createCommentVNode("", true),
                          _createElementVNode("div", _hoisted_12, [
                            _createElementVNode("p", null, _toDisplayString(item.pointName), 1)
                          ])
                        ], 8, _hoisted_9))
                      }), 128))
                    ]),
                    _: 1
                  })
                ]),
                _createElementVNode("div", _hoisted_13, [
                  _createElementVNode("span", _hoisted_14, "共计 " + _toDisplayString(state.total) + " 条", 1),
                  _createVNode(_component_el_pagination, {
                    class: "pagination-style small-pagination",
                    "current-page": state.pagination.current,
                    "page-size": state.pagination.size,
                    "page-sizes": state.pagination.pageSizes,
                    total: state.total,
                    layout: "total, sizes, prev, pager, next, jumper",
                    background: "",
                    onSizeChange: handleSizeChange,
                    onCurrentChange: handleCurrentChange
                  }, null, 8, ["current-page", "page-size", "page-sizes", "total"])
                ])
              ]))
            : (_openBlock(), _createElementBlock("div", _hoisted_15, _cache[5] || (_cache[5] = [
                _createElementVNode("img", {
                  src: _imports_1,
                  alt: ""
                }, null, -1),
                _createElementVNode("span", null, "暂无数据", -1)
              ])))
        ])
      ])
    ], 512), [
      [_vShow, !state.isShowDialog]
    ]),
    _withDirectives(_createElementVNode("div", _hoisted_16, [
      _createElementVNode("div", _hoisted_17, [
        _createElementVNode("div", _hoisted_18, [
          _createElementVNode("div", _hoisted_19, [
            _createVNode(_component_vkm_svg, {
              "icon-name": "back",
              class: "icon",
              onClick: _cache[1] || (_cache[1] = ()=>{ state.isShowDialog = false})
            }),
            _createElementVNode("span", null, _toDisplayString(actionNamge.value), 1)
          ]),
          _createElementVNode("div", _hoisted_20, [
            _createElementVNode("span", {
              class: _normalizeClass(['detail-prompt-text', imageIsPass.value ? 'detail-qualified' : 'detail-unqualified'])
            }, _toDisplayString(imageIsPass.value?'图片质量合格':unqualifiedDescription.value), 3),
            _createVNode(_component_vkn_button, {
              label: state.showReferenceImage ? '关闭参考图' : '打开参考图',
              type: "info",
              "icon-placement": "left",
              size: "medium",
              onClick: _cache[2] || (_cache[2] = ()=>{ state.showReferenceImage = !state.showReferenceImage})
            }, null, 8, ["label"])
          ])
        ]),
        _withDirectives(_createElementVNode("div", _hoisted_21, [
          _createElementVNode("div", _hoisted_22, [
            _createElementVNode("div", _hoisted_23, [
              _createElementVNode("i", {
                class: _normalizeClass(['iconfont-line vk_prevleft_line', state.pagination.current > 1 || state.currentResourceIndex != 0? 'click-btn': 'none-click-btn']),
                onClick: prevResource
              }, null, 2)
            ]),
            _createElementVNode("div", _hoisted_24, [
              (state.showReferenceImage && referenceUrl.value)
                ? (_openBlock(), _createElementBlock("div", _hoisted_25, [
                    _createElementVNode("div", _hoisted_26, [
                      _cache[6] || (_cache[6] = _createElementVNode("div", { class: "reference-photos-title" }, [
                        _createElementVNode("span", null, "参考照片")
                      ], -1)),
                      _createElementVNode("img", {
                        src: state.baseUrl+referenceUrl.value,
                        alt: ""
                      }, null, 8, _hoisted_27)
                    ])
                  ]))
                : _createCommentVNode("", true),
              _createElementVNode("div", {
                class: "main-image-wrapper",
                ref: "mainImageWrapper",
                onWheel: zoom,
                onMousedown: startDrag,
                onMousemove: doDrag,
                onMouseup: stopDrag
              }, [
                _createElementVNode("img", {
                  draggable: "false",
                  src: state.baseUrl+imageSrc.value,
                  ref: "image",
                  class: "main-image draggable-image",
                  style: _normalizeStyle(imageStyle.value)
                }, null, 12, _hoisted_28)
              ], 544)
            ]),
            _createElementVNode("div", _hoisted_29, [
              _createElementVNode("i", {
                class: _normalizeClass(['iconfont-line vk_prevright_line', state.pagination.current < state.pagination.totalSize || state.currentResourceIndex < state.sourceList.length - 1? 'click-btn': 'none-click-btn']),
                onClick: nextResource
              }, null, 2)
            ])
          ]),
          _createElementVNode("div", _hoisted_30, [
            _createElementVNode("div", _hoisted_31, [
              _createElementVNode("i", {
                class: "iconfont-line vk_js_line1",
                onClick: zoomOut
              }),
              _createElementVNode("span", { onClick: resetImage }, _toDisplayString(scalePercentage.value) + "%", 1),
              _createElementVNode("i", {
                class: "iconfont-line vk_fd_line",
                onClick: zoomIn
              })
            ])
          ])
        ], 512), [
          [_vShow, imageSrc.value]
        ])
      ])
    ], 512), [
      [_vShow, state.isShowDialog]
    ])
  ]))
}
}

})